// AUTO-GENERATED by scripts/scan-data-tour.ts. Do not edit by hand.
// Regenerate with: pnpm tsx scripts/scan-data-tour.ts
//
// This list feeds the admin tour step editor's Target ID combo box.
// Tour authors may save unknown ids (with a warning) — the runtime
// silently skips steps whose target is missing from the DOM.
export const DATA_TOUR_IDS = [
  "${escaped}",
  "${s.targetId}",
  "${target.id}",
  "dashboard-high-severity-alerts",
  "dashboard-location-card",
  "dashboard-location-strip",
  "dashboard-recently-viewed",
  "dashboard-system-status",
  "nav-sidebar-admin-glossary",
  "nav-sidebar-admin-settings",
  "nav-sidebar-admin-tasks",
  "nav-sidebar-admin-tours",
  "nav-sidebar-admin-users",
  "nav-sidebar-animals",
  "nav-sidebar-behavior",
  "nav-sidebar-counts",
  "nav-sidebar-dashboard",
  "nav-sidebar-files",
  "nav-sidebar-interactions",
  "nav-sidebar-logs",
  "nav-sidebar-meetings",
  "nav-sidebar-population",
  "nav-sidebar-reports",
  "nav-sidebar-summaries",
  "nav-sidebar-tasks",
  "{trimmedTargetId}",
] as const;

export type DataTourId = (typeof DATA_TOUR_IDS)[number];
